import { AbstractChart } from './abstract_chart';

class LineChart extends AbstractChart {

	constructor(element) {
		super(element, 'line');
	}

}

const line = (element) => {
	return new LineChart(element);
};


export {
	line
}
